import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import useNichoAtual from "./hooks/useNichoAtual";
import Modal from "./components/Modal";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ProvaSocial from "./components/ProvaSocial";
import SecaoAutomacaoVisual from "./components/SecaoAutomacaoVisual";
import SecaoMultichannel from "./components/SecaoMultichannel";
import SecaoIvo from "./components/SecaoIvo";
import ComoFunciona from "./components/ComoFunciona";
import Pricing from "./components/Pricing";
import Faq from "./components/Faq";
import SecaoLoginGoogle from "./components/SecaoLoginGoogle";
import Footer from "./components/Footer";
import ApresentacaoPage from "./components/ApresentacaoPage";


function HomePage() {
  const { nicho, conteudo, modalAberto, selecionarNicho, trocarNicho } = useNichoAtual();

  // SEO dinamico da home — depende do nicho selecionado
  useEffect(() => {
    // So personaliza quando o visitante escolheu um nicho de fato: sem escolha,
    // o hook devolve o nicho de fundo, que nao deve vazar pro title/meta.
    const c = nicho ? conteudo : null;
    document.title = c
      ? `Evolzap — Sistema para ${c.nome}`
      : "Evolzap — Sistema de atendimento e gestão multichannel";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        c
          ? c.hero.subtitulo
          : "Sistema de atendimento e gestão multichannel pra pequenos e médios negócios."
      );
    }
  }, [nicho, conteudo]);

  return (
    <div className="App min-h-screen bg-[#0A0A0A] text-white">
      <Header conteudo={conteudo} onTrocarNicho={trocarNicho} />
      <main key={conteudo.slug} className="animate-fade-in">
        <Hero />
        <ProvaSocial />
        <SecaoAutomacaoVisual />
        <SecaoMultichannel />
        <SecaoIvo conteudo={conteudo} />
        <ComoFunciona conteudo={conteudo} />
        <Pricing conteudo={conteudo} />
        <Faq conteudo={conteudo} onTrocarNicho={trocarNicho} />
      </main>
      <Footer conteudo={conteudo} onTrocarNicho={trocarNicho} />
      {modalAberto && <Modal onSelecionar={selecionarNicho} />}
    </div>
  );
}

function PrivacidadeGooglePage() {
  const { conteudo, modalAberto, selecionarNicho, trocarNicho } = useNichoAtual();

  // SEO dinamico da pagina de privacidade
  useEffect(() => {
    document.title = "Evolzap — Login com Google e Privacidade";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Como o Evolzap usa sua conta Google. Escopo minimo, sem leitura de e-mails ou Drive."
      );
    }
    // Volta pro topo ao entrar na pagina
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App min-h-screen bg-[#0A0A0A] text-white">
      <Header conteudo={conteudo} onTrocarNicho={trocarNicho} />
      <main className="animate-fade-in pt-8">
        <SecaoLoginGoogle />
      </main>
      <Footer conteudo={conteudo} onTrocarNicho={trocarNicho} />
      {modalAberto && <Modal onSelecionar={selecionarNicho} />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacidade-google" element={<PrivacidadeGooglePage />} />
        <Route path="/apresentacao" element={<ApresentacaoPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
